import { Row } from '@shipt/design-system-layouts'
import { Body } from '@shipt/design-system-typography'
import { ProductDetailStars } from '@/features/shop/components/ProductDetailRatingsAndReviews/ProductDetailStars'
import styled from 'styled-components'
import { TransparentButton } from '@/features/shared/elements/Buttons'
import { trackElementClicked } from '@/features/shared/analytics/element'
import { pluralizer } from '@/features/shared/utils/formatter'

type Props = {
  scrollToSection: () => void
  avgRating: number
  isUnderline: boolean
  totalRatings: number
}

type RatingsAndReviewsProps = Omit<Props, 'scrollToSection' | 'avgRating' | 'totalReviews'>

const RatingsAndReviewsCount = ({ isUnderline, totalRatings }: RatingsAndReviewsProps) => {
  const pluralizedRatingsText = pluralizer('rating', totalRatings)
  return (
    <ReviewsCount variant="secondary" underline={isUnderline}>
      ({totalRatings} {pluralizedRatingsText})
    </ReviewsCount>
  )
}

export const ProductDetailRatingInfo = ({
  scrollToSection,
  avgRating,
  isUnderline,
  totalRatings,
}: Props) => {
  const pluralizedRatingsText = pluralizer('rating', totalRatings)
  return (
    <Row
      spacing="xs"
      marginTop="xs"
      align="center"
      role="group"
      aria-label={`Average rating of ${avgRating.toFixed(
        1,
      )} out of 5 stars based on ${totalRatings} ${pluralizedRatingsText}`}
    >
      <Body aria-hidden="true">{avgRating.toFixed(1)}</Body>
      <ProductDetailStars rating={avgRating} size="md" />
      {!!isUnderline && (
        <TransparentButton
          onClick={() => {
            scrollToSection()
            trackElementClicked({
              content: 'num_ratings',
              type: 'button',
            })
          }}
          aria-label={`Read ${totalRatings} ${pluralizedRatingsText}`}
        >
          <RatingsAndReviewsCount isUnderline totalRatings={totalRatings} />
        </TransparentButton>
      )}
      {!isUnderline && <RatingsAndReviewsCount isUnderline={false} totalRatings={totalRatings} />}
    </Row>
  )
}
const ReviewsCount = styled(Body)<{ underline?: boolean }>`
  text-decoration: ${({ underline }) => (underline ? 'underline' : 'none')};
`
